// extracted by mini-css-extract-plugin
var _1 = "Stars__hidden--kXbHV";
export { _1 as "hidden" }
